import React from "react";
import notfoundImg from "../../images/emptyImg.png";

const NoData = ({ text = "No Data" }) => {
  
  return (
    <div className=" flex items-center justify-center flex-col gap-2">
      <img className="" src={notfoundImg} />
      <h3 className=" text-[20px] font-medium text-black opacity-[0.2]">
        {text}
      </h3>
    </div>
  );
};

export default NoData;
